module.exports = __webpack_public_path__ + "static/media/after-hours.ecf46a1e.jpg";